import {
  Add,
  ArrowDropDown,
  ArrowDropUp,
  ChevronRight,
  ContentCopy,
  Delete,
  Event,
  ExpandMore,
  Info,
  KeyboardArrowDown,
  Search,
} from "@mui/icons-material";
import {
  Button,
  Card,
  Checkbox,
  ClickAwayListener,
  Divider,
  FormControlLabel,
  IconButton,
  Link,
  MenuItem,
  Modal,
  OutlinedInput,
  Popper,
  Grid,
  Radio,
  RadioGroup,
  Select,
  Tooltip,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { useState, useEffect, useRef } from "react";
import { dayjs } from "dayjs";
import TextField from "@mui/material/TextField";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import { StaticDateRangePicker } from "@mui/x-date-pickers-pro/StaticDateRangePicker";
import { DateRange, DateRangePicker } from "@mui/x-date-pickers-pro";
import Box from "@mui/material/Box";
import {
  addDays,
  addHours,
  differenceInMinutes,
  format,
  isAfter,
  isBefore,
  parse,
  subDays,
} from "date-fns";
import { gql, useMutation, useQuery } from "@apollo/client";
import HourFormat from "../../util/hourFormat";
import Error from "../Error";
import { BpCheckedIcon, BpIcon } from "../../util/BPcheckbox";
import {
  ADD_COMPANY_HOUR,
  DELETE_COMPANY_HOUR,
  UPDATE_COMPANY_HOUR,
  addCompanyHourGroup,
} from "../../graphql/mutations";
import {
  getCompanyGroupsHours,
  getCompanyHours,
  getOverrideGroups,
  getOverrides,
} from "../../graphql/querys";
import SimplePopper from "./SimplePopper";
import { images } from "../../util/images";
import EthiopianDatePicker, {
  habeshaFormat,
} from "../../util/Ethiopia/EthiopianDatePicker";
import PopupState, { bindToggle, bindPopper } from "material-ui-popup-state";
import Fade from "@mui/material/Fade";
import Paper from "@mui/material/Paper";
const Cancel = styled((props) => (
  <Button disableRipple variant="outlined" {...props} />
))({
  color: "black",
  border: "none",
  height: "30px",
  "&:hover": {
    backgroundColor: "transparent",
    border: "none",
  },
});
const Next = styled((props) => <Button variant="contained" {...props} />)({
  color: "white",
  borderRadius: "30px",
  height: "30px",
  background: "#d9bca9",
  boxShadow: "none",
});

const EventTime = (props) => {
  const [addCompanyHourGroups] = useMutation(addCompanyHourGroup);
  const scrollToSection = (ref) => {
    setTimeout(() => {
      const section2 = document.getElementById(ref);
      section2.scrollIntoView(true);
    }, 100);
  };
  const [showCancelModal, setShowCancelModal] = useState(false);
  const { loading, error, data, refetch } = useQuery(getCompanyHours, {
    variables: {
      userId: props.currentUser, // Replace with the user ID you want to filter by
      hours24: HourFormat(),
    },
  });
  const {
    loading: groupLoading,
    error: groupError,
    data: groupData,
    refetch: groupRefetch,
  } = useQuery(getCompanyGroupsHours, {
    variables: {
      userId: props.currentUser, // Replace with the user ID you want to filter by
      custom: true,
    },
  });
  const {
    loading: groupLoadingPre,
    error: groupErrorPre,
    data: groupDataPre,
    refetch: groupRefetchPre,
  } = useQuery(getCompanyGroupsHours, {
    variables: {
      userId: props.currentUser, // Replace with the user ID you want to filter by
      custom: false,
    },
  });
  const {
    loading: overrideLoading,
    error: overrideError,
    data: overrideData,
    refetch: overrideRefetch,
  } = useQuery(getOverrides, {
    variables: {
      userId: props.currentUser,
      hours24: HourFormat(),
    },
  });
  const {
    loading: overrideGroupLoading,
    error: overrideGroupError,
    data: overrideGroupData,
    refetch: overrideGroupRefetch,
  } = useQuery(getOverrideGroups, {
    variables: {
      userId: props.currentUser,
    },
  });

  const [typeOTime, setType] = useState("min");
  const optionsSelect = ["15 min", "30 min", "45 min", "60 min", "Custom"];
  const optionsRefer = [15, 30, 45, 60];
  const [select, setSelect] = useState(
    props.update
      ? optionsRefer.includes(props.update.length)
        ? optionsSelect[optionsRefer.indexOf(props.update.length)]
        : "Custom"
      : "30 min"
  );
  const [custom, setCustom] = useState(
    props.update
      ? groupData?.getCompanyGroupsHours.find(
          (obj) => props.update.groupId == obj?.id
        )?.custom
        ? true
        : false
      : false
  );
  const [selects, setSelects] = useState(
    (
      props.update
        ? groupData?.getCompanyGroupsHours.find(
            (obj) => props.update.groupId == obj?.id
          )?.custom
          ? true
          : false
        : custom
    )
      ? props.update.groupId
      : groupDataPre
      ? groupDataPre?.getCompanyGroupsHours[0]?.id
      : ""
  );
  const [tooltip, setTooltipOpen] = useState([
    false,
    false,
    false,
    false,
    false,
  ]);
  const [bookingOption, setBookingOption] = useState(
    props?.update
      ? props.update?.specialBookingOption
        ? props.update?.specialBookingOption
        : props.update?.bookingOption
      : "60Days"
  );
  const [daysInput, setDaysInput] = useState(props.update?.start || new Date());
  const [daysIndefInput, setDaysIndefInput] = useState(
    props.update?.start || new Date()
  );
  const [value, setValue] = React.useState(
    !props.update ||
      props.bookingOption != "dateRange" ||
      ["week", "month", "year"].includes(props?.update?.end.split(" ")[0])
      ? [new Date().toString(), new Date(addDays(new Date(), 1)).toString()]
      : [
          props.update ? props.update.start : null,
          props.update ? props.update.end : null,
        ]
  );
  const [hrsOmins, setHrsOMins] = useState(
    props.update ? props.update.length : 0
  );
  const [eventsPerDay, setEventsPerDay] = useState(
    props.update ? props.update.eventsPerDay : null
  );
  const [increments, setIncrements] = React.useState(
    props.update ? props.update.increments : 30
  );
  const [advancedOpen, setAdvancedOpen] = useState(
    props.update
      ? !props.update.eventsPerDay || props.update.increments !== 30
      : false
  );
  const [hidden, setHidden] = useState(
    props.update ? props.update.hidden : false
  );
  const [searchImages, setSearchImages] = useState("");
  const [recurringValue1, setRecurringValue1] = useState(
    props.update && props.update.bookingOption == "recur1"
      ? new Date(props.update?.end.split(" ")[1])
      : new Date()
  );
  const [recurring1, setRecurring1] = useState(
    props.update && props.update.bookingOption == "recur1"
      ? props.update?.end.split(" ")[0]
      : "week"
  );
  const [recurringValue2, setRecurringValue2] = useState(
    props.update && props.update.bookingOption == "recur2"
      ? new Date(props.update.end.split(" ")[1])
      : new Date()
  );
  const [recurring2, setRecurring2] = useState(
    props.update && props.update.bookingOption == "recur2"
      ? parseInt(props.update.end.split(" ")[0])
      : 10
  );
  const [errors, setErrors] = useState([
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ]);
  const [goforit, setGoForIt] = useState(false);
  const [hasCreated, setHasCreated] = useState(
    props.update
      ? groupData?.getCompanyGroupsHours.find(
          (obj) => props.update.groupId == obj?.id
        )?.custom
        ? true
        : false
      : false
  );
  function sett(ee, n, news, loc) {
    if (n) {
      news[ee] = true;
    } else {
      news[ee] = false;
    }
    setGoForIt(loc);
    setErrors(news);
  }
  const validateForm = () => {
    // Check if all required inputs have a value
    if (
      !(bookingOption == "recur1"
        ? recurringValue1?.$d || recurringValue1
        : true) ||
      !(bookingOption == "recur2"
        ? recurring2 >= 2 && (recurringValue2?.$d || recurringValue2)
        : true) ||
      !(bookingOption == "indefinitely"
        ? daysIndefInput || daysIndefInput?.$d
        : true) ||
      !(bookingOption == "60Days" ? daysInput || daysInput?.$d : true) ||
      (select == "Custom" && !hrsOmins) ||
      (bookingOption == "dateRange"
        ? !(
            (value[0]?.$d ? value[0]?.$d : value[0]) &&
            (value[1]?.$d ? value[1]?.$d : value[1])
          )
        : false)
    ) {
      var news = [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ];
      sett(0, select == "Custom" && !hrsOmins, news, "hrsOMins");
      bookingOption == "dateRange" &&
        sett(1, value[0]?.$d ? !value[0]?.$d : !value[0], news, "date");
      bookingOption == "dateRange" &&
        sett(2, value[1]?.$d ? !value[1]?.$d : !value[1], news, "date");
      bookingOption == "recur1" &&
        sett(
          3,
          !(recurringValue1?.$d || recurringValue1),
          news,
          "indefinitely"
        );
      bookingOption == "recur2" &&
        sett(4, !(recurringValue2?.$d || recurringValue2), news, "recur1");
      bookingOption == "recur2" && sett(5, recurring2 < 2, news, "recur1");
      bookingOption == "60Days" &&
        sett(6, !(daysInput || daysInput?.$d), news, "dateRange");
      bookingOption == "indefinitely" &&
        sett(7, !(daysIndefInput || daysIndefInput?.$d), news, "dateRange");
      return false;
    }
    var news = [false, false, false, false, false, false, false, false, false];
    setErrors(news);
    setGoForIt(null);
    return true;
  };
  const [formCompleted, setCompleted] = useState(false);
  useEffect(() => {
    validateForm();
  }, [
    value,
    hrsOmins,
    recurring2,
    recurringValue1,
    recurringValue2,
    daysInput,
  ]);
  const [selectionRange, setSelectionRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });
  const createNewAvailability = (props, next, pr) => {
    addCompanyHour({
      variables: props,
    })
      .then((res) => {
        console.log(res);

        refetch();
        groupRefetch();
      })
      .catch((err) => {
        console.log(err);
        refetch();
        groupRefetch();
      });
  };
  const [addCompanyHour] = useMutation(ADD_COMPANY_HOUR);
  const [deleteCompanyHour] = useMutation(DELETE_COMPANY_HOUR);
  const [updateCompanyHour] = useMutation(UPDATE_COMPANY_HOUR);
  const [selectedDateRange, setSelectedDateRange] = useState([
    props.update ? props.update.start : null,
    props.update ? props.update.end : null,
  ]);
  const [days, setDays] = useState(60);

  useEffect(() => {
    if (!loading && !groupLoading && !groupLoadingPre) {
      setSelects(
        props.update
          ? groupData?.getCompanyGroupsHours.find(
              (obj) => props.update.groupId == obj?.id
            )?.custom && !custom
            ? groupDataPre?.getCompanyGroupsHours[0]?.id
            : props.update.groupId
          : groupDataPre
          ? groupDataPre?.getCompanyGroupsHours.find((val) => val.id == selects)
            ? selects
            : groupDataPre?.getCompanyGroupsHours[0].id
          : ""
      );
    }
  }, [
    loading,
    groupLoading,
    groupLoadingPre,
    groupData,
    groupDataPre,
    props.update,
    custom,
  ]);

  useEffect(() => {
    refetch();
  }, []);
  useEffect(() => {
    if (groupData?.getCompanyGroupsHours) {
      setHasCreated(
        props.update
          ? groupData?.getCompanyGroupsHours.find(
              (obj) => props.update.groupId == obj?.id
            )?.custom
            ? true
            : false
          : hasCreated
      );
      setCustom(
        props.update
          ? groupData?.getCompanyGroupsHours.find(
              (obj) => props.update.groupId == obj?.id
            )?.custom
            ? true
            : false
          : custom
      );
    }
  }, [groupData]);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const [groupId, setGroupId] = useState(
    props.update ? props.update.groupId : ""
  );
  const [image, setImage] = useState(props.update ? props.update.image : 0);
  const errorTimeoutRef = useRef(null);
  const errorTimeoutActiveRef = useRef(false);
  const errorRef = useRef(null);
  const [errorUpdating, setErrorUpdating] = useState(false);
  useEffect(() => {
    if (errorUpdating && !errorTimeoutActiveRef.current) {
      errorTimeoutActiveRef.current = true;

      errorTimeoutRef.current = setTimeout(() => {
        setErrorUpdating(false);
        errorTimeoutActiveRef.current = false;
      }, 2000);
    }

    return () => {
      clearTimeout(errorTimeoutRef.current);
      errorTimeoutActiveRef.current = false;
    };
  }, [errorUpdating]);
  useEffect(() => {
    if (errorRef.current) {
      errorRef.current.style.height = "0px";

      if (errorUpdating) {
        errorRef.current.style.transition = "height 0.3s ease";
        errorRef.current.style.height = "50px";
      } else {
        errorRef.current.style.height = "0px";
      }
    }
  }, [errorUpdating]);
  const [currentInputValues, setCurrentInputValues] = useState({});
  const [modifiedDays, setModifiedDays] = useState({
    Sunday: [],
    Monday: [],
    Tuesday: [],
    Wednesday: [],
    Thursday: [],
    Friday: [],
    Saturday: [],
  });

  if (error) {
    console.log(error);
    return <Error />;
  } else {
    props.setShow(true);
  }
  const handleFormSubmit = (send) => {
    const isValid = validateForm();
    if (!isValid) {
      scrollToSection(goforit);
      setCompleted(true);
      return;
    }
    props.setUpdating(true);
    setCompleted(true);
    var final = {
      eventId: parseInt(props.id) ? parseInt(props.id) : null,
      groupId: custom ? parseInt(groupId) : parseInt(selects),
      title: props.title,
      location: props.locationInput,
      desc: props.desc,
      color: props.color,
      phoneNumber: props.phoneNumber,
      phoneNumberRadio: props.radio,
      link: props.link,
      eventType: props.group ? "group" : "one",
      location: props.location,
      bookingOption,
      locationType: props.locationType,
      eventsPerDay: eventsPerDay ? parseInt(eventsPerDay) : null,
      increments,
      hidden,
      image,
      start:
        bookingOption == "60Days" || bookingOption == "indefinitely"
          ? new Date(
              bookingOption == "60Days" ? daysInput : daysIndefInput
            ).toISOString()
          : bookingOption == "recur1"
          ? new Date(recurringValue1?.$d || recurringValue1).toISOString()
          : bookingOption == "recur2"
          ? new Date(recurringValue2?.$d || recurringValue2).toISOString()
          : new Date(value[0]?.$d ? value[0].$d : value[0]).toISOString(),

      end:
        bookingOption === "60Days"
          ? addDays(new Date(daysInput), days).toISOString()
          : bookingOption == "indefinitely"
          ? addDays(new Date(daysIndefInput), 1000000).toISOString()
          : bookingOption == "recur1"
          ? recurring1 +
            " " +
            new Date(recurringValue1?.$d || recurringValue1).toISOString()
          : bookingOption == "recur2"
          ? recurring2 +
            " " +
            new Date(recurringValue2?.$d || recurringValue2).toISOString()
          : new Date(value[1]?.$d ? value[1].$d : value[1]).toISOString(),
      length:
        hrsOmins && select == "Custom"
          ? hrsOmins * (typeOTime == "min" ? 1 : 60)
          : parseInt(select.slice(0, 2)),
      bookingApproval: props.bookingApproval,
    };
    if (props.group) {
      final.maxInvitees = parseInt(props.maxNum);
      final.showRemaining = props.remaining ? true : false;
    }
    if (!props.update) {
      final.companyId = props.currentUser;
    }
    !props.goforit && props.setSelectedTab(null);
    props.goforit ? props.handle(props.goforit) : props.handleSubmit(final);
  };
  const handleCancel = () => {
    // perform the cancel action here
    window.location.href = "/app/events";
  };
  const handleNevermind = () => {
    // do nothing
  };

  const handleCreateCustomGroup = () => {
    addCompanyHourGroups({
      variables: {
        input: [
          {
            userId: props.currentUser,
            custom: true,
            def: false,
            title: "My custom hour group",
          },
        ],
      },
    })
      .then((res) => {
        setHasCreated(res.data.addCompanyHourGroup.id);
        setGroupId(res.data.addCompanyHourGroup.id);
        refetch();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const CancelModal = () => {
    return (
      <Modal open={showCancelModal} onClose={() => setShowCancelModal(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: "10px",
            outline: "none",
            maxWidth: "400px",
          }}
        >
          <Typography variant="h5" sx={{ mb: 2 }}>
            Are you sure you want to cancel?
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              variant="contained"
              onClick={() => setShowCancelModal(false)}
              sx={{ mr: 2 }}
              style={{ background: "#d9bca9" }}
            >
              Nevermind
            </Button>
            <Button variant="outlined" onClick={() => handleCancel()}>
              Yes
            </Button>
          </Box>
        </Box>
      </Modal>
    );
  };
  const handleDateRangeChange = (newValue) => {
    setSelectedDateRange(newValue);
  };
  const Tool = (props) => {
    const handleTooltipOpen = (i) => {
      var e = tooltip.slice();
      e[i] = true;
      setTooltipOpen(e);
    };

    const handleTooltipClose = (i) => {
      var e = tooltip.slice();
      e[i] = false;
      setTooltipOpen(e);
    };
    return (
      <Tooltip
        title={tooltipContent[props.num]}
        placement="right"
        open={tooltip[props.num]}
        onClose={() => handleTooltipClose(props.num)}
        onOpen={() => handleTooltipOpen(props.num)}
        arrow
        style={{ width: "10px", height: "10px" }}
        classes={{
          tooltip: "tooltip",
          arrow: "tooltip-arrow",
        }}
      >
        <IconButton
          aria-label="tooltip"
          onClick={() => handleTooltipOpen}
          onMouseEnter={() => handleTooltipOpen}
          onMouseLeave={() => handleTooltipClose}
          className="icon-button"
          style={{ width: "15px", height: "15px" }}
        >
          <Info className="icon" style={{ width: "15px", height: "15px" }} />
        </IconButton>
      </Tooltip>
    );
  };
  const handleKeyPress = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);

    // Only allow digits and backspace/delete
    if (!/^\d$/.test(keyValue) && keyCode !== 8 && keyCode !== 46) {
      event.preventDefault();
    }

    // Only allow integers above 0
    const newValue = parseInt(event.target.value + keyValue);
    if (isNaN(newValue) || newValue < 1) {
      event.preventDefault();
    }
  };
  const handleBookingOptionChange = (event) => {
    setBookingOption(event.target.value);
  };

  const handleSelect = (ranges) => {
    setSelectionRange(ranges.selection);
  };
  const tooltipContent = [
    "Set a range of dates when you can accept meetings.",
    "Define how long your event will be. It can be as long as 12 hours.",
    "Select one of your schedules or define custom hours specific to this type of event.",
    "Enter an event link that describes your event.",
    "Choose a color for your event.",
  ];
  const isTimeRangeOverlap = (range1, range2) => {
    // Parse the times
    const range1Start = parse(range1.startTime, HourFormat(), new Date());
    const range1End = parse(range1.endTime, HourFormat(), new Date());

    if (Array.isArray(range2)) {
      return range2.some((r2) => {
        const range2Start = parse(r2.startTime, HourFormat(), new Date());
        const range2End = parse(r2.endTime, HourFormat(), new Date());

        return (
          (isAfter(range1Start, range2Start) &&
            isBefore(range1Start, range2End)) ||
          (isAfter(range2Start, range1Start) &&
            isBefore(range2Start, range1End))
        );
      });
    } else {
      const range2Start = parse(range2.startTime, HourFormat(), new Date());
      const range2End = parse(range2.endTime, HourFormat(), new Date());

      return (
        (isAfter(range1Start, range2Start) &&
          isBefore(range1Start, range2End)) ||
        (isAfter(range2Start, range1Start) && isBefore(range2Start, range1End))
      );
    }
  };
  const handleInputChange = (i, type, result, day) => {
    setCurrentInputValues((prevState) => {
      const dayInputs = prevState[day] || [];
      const inputIndex = dayInputs.findIndex((input) => input.id == i);
      if (inputIndex === -1) {
        // this input has not been modified before
        dayInputs.push({
          id: i,
          [type]: result,
          groupId: parseInt(custom ? groupId : selects),
        });
      } else {
        // this input has been modified before
        dayInputs[inputIndex][type] = result;
      }
      return { ...prevState, [day]: dayInputs };
    });
  };
  const handleSaveClick = (day) => {
    if (!modifiedDays[day]) {
      // No changes were made to this day, so we do nothing.
      return;
    }

    var dayInputs = currentInputValues[day] || [];

    // Get the original hours for this day from the company data with the same groupId
    var originalHours = data.getCompanyHours.filter(
      (obj) =>
        obj.day === day &&
        parseInt(custom ? groupId : selects) == parseInt(obj.groupId)
    );

    // Sort the combined list by start time
    var sortedHours = originalHours.sort((a, b) => {
      const aStart = parse(a.start, HourFormat(), new Date());
      const bStart = parse(b.start, HourFormat(), new Date());
      return aStart - bStart;
    });
    const id = dayInputs[0]?.id;
    var final = sortedHours.map((val) => {
      var check = val.id == id;
      if (check) {
        return {
          ...val,
          startTime: dayInputs[0]?.start || val.startTime,
          endTime: dayInputs[0]?.end || val.endTime,
        };
      } else {
        return val;
      }
    });
    for (var i = 0; i < final.length; i++) {
      for (var j = 0; j < final.length; j++) {
        if (j == i) {
          continue;
        }
        if (isTimeRangeOverlap(final[i], final[j])) {
          setErrorUpdating("Overlapping Times");
          return;
        }
      }
    }

    dayInputs.forEach((input) => {
      const { id: hourId, start, end, check } = input;

      const dat = data.getCompanyHours.find(
        (obj) => parseInt(obj.id) === hourId
      );
      if (
        (end &&
          new Date(parse(end, HourFormat(), new Date())) == "Invalid Date") ||
        (start &&
          new Date(parse(start, HourFormat(), new Date())) == "Invalid Date")
      ) {
        setCurrentInputValues({});
        setErrorUpdating("Invalid Time");
        return;
      }
      const hourInput = {
        day: day,
        onJob: check ?? dat?.onJob,
        startTime: start
          ? format(new Date(parse(start, HourFormat(), new Date())), "hh:mmaa")
          : format(
              new Date(parse(dat?.startTime, HourFormat(), new Date())),
              "hh:mmaa"
            ),
        endTime: end
          ? format(new Date(parse(end, HourFormat(), new Date())), "hh:mmaa")
          : format(
              new Date(parse(dat?.endTime, HourFormat(), new Date())),
              "hh:mmaa"
            ),
        groupId: parseInt(custom ? groupId : selects),
      };

      if (
        !differenceInMinutes(
          new Date(parse(hourInput.startTime, "h:mmaa", new Date())),
          new Date(parse(hourInput.endTime, "h:mmaa", new Date()))
        ) ||
        isAfter(
          new Date(parse(hourInput.startTime, "h:mmaa", new Date())),
          new Date(parse(hourInput.endTime, "h:mmaa", new Date()))
        )
      ) {
        setErrorUpdating("Times are not proper");
        return;
      }
      updateCompanyHour({
        variables: { hourId: hourId, hourInput },
      })
        .then((result) => {
          refetch({
            userId: props.currentUser,
            hours24: HourFormat(),
          });
          groupRefetch();
        })
        .catch((error) => {
          console.log(error);
          refetch({
            userId: props.currentUser,
            hours24: HourFormat(),
          });
          groupRefetch();
        });

      // reset the modified state for this day to null after save
      setModifiedDays((prevState) => {
        const dayInputs = prevState[day].filter((input) => input.id !== hourId);
        return { ...prevState, [day]: dayInputs };
      });
    });
    setCurrentInputValues((prevState) => ({ ...prevState, [day]: [] }));
  };
  const handleUpdateMondayHours = (i, type, result) => {
    const hourId = i;
    var dat = data.getCompanyHours.find((obj) => parseInt(obj.id) == i);
    const hourInput = {
      day: dat?.day,
      onJob: type == "check" ? result : dat?.onJob,
      startTime: format(
        new Date(parse(dat?.startTime, HourFormat(), new Date())),
        "hh:mmaa"
      ),
      endTime: format(
        new Date(parse(dat?.endTime, HourFormat(), new Date())),
        "hh:mmaa"
      ),
      groupId: parseInt(custom ? groupId : selects),
    };

    updateCompanyHour({
      variables: { hourId, hourInput },
    })
      .then((result) => {
        refetch({
          userId: props.currentUser, // Replace with the user ID you want to filter by
          hours24: HourFormat(),
        });
        groupRefetch();
      })
      .catch((error) => {
        console.log(error);
        refetch();
        groupRefetch();
      });
  };
  return (
    <div className="addEventBox" id="section2">
      <div
        className="Top"
        style={{ cursor: "pointer" }}
        onClick={() => {
          props.setSelectedTab(props.selectedTab !== 1 ? 1 : null);
        }}
      >
        <div
          style={{
            height: "65px",
            display: "flex",
            gap: 20,
            alignItems: "center",
          }}
        >
          <Event size="30px" />
          <h3 style={{ fontWeight: 400, margin: "0px 20px 0px 0" }}>
            When can people book this event?
          </h3>
        </div>
      </div>
      <Divider />
      <div
        style={{
          display:
            (props.selectedTab !== 1 ||
              loading ||
              groupLoading ||
              groupLoadingPre ||
              overrideLoading ||
              overrideGroupLoading) &&
            "none",
        }}
      >
        <div className="form-control" style={{ padding: "20px 40px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              height: "40px",
              gap: "15px",
            }}
          >
            <h4 id="dateRange">Date range</h4>
            <Tool num={0} />
          </div>
          <div>
            <h4 style={{ fontWeight: 400 }}>Invitees can schedule...</h4>
            <RadioGroup
              value={bookingOption}
              onChange={handleBookingOptionChange}
              className="flex column"
              style={{ gap: "20px" }}
            >
              <FormControlLabel
                value="60Days"
                id="date"
                control={<Radio />}
                label={
                  <Grid container alignItems="center" spacing={2}>
                    <Grid item>
                      <Typography>Up to</Typography>
                    </Grid>
                    <Grid item>
                      <OutlinedInput
                        style={{
                          width: "60px",
                          height: "40px",
                          fontSize: "1rem",
                          textAlign: "center",
                          borderRadius: "10px",
                        }}
                        type="text"
                        value={days}
                        onChange={(event) => setDays(event.target.value)}
                        onKeyPress={handleKeyPress}
                        inputProps={{
                          maxLength: 3,
                        }}
                      />
                    </Grid>
                    <Grid item>
                      <Typography>days into the future from</Typography>
                    </Grid>
                    <Grid item>
                      {props.decodedToken.calendar == "Ethiopian" ? (
                        <PopupState
                          variant="popper"
                          popupId="demo-popup-popper"
                        >
                          {(popupState) => (
                            <div>
                              <OutlinedInput
                                label="Date"
                                value={habeshaFormat(
                                  new Date(daysInput),
                                  "MMMdd yyyy"
                                )}
                                variant="contained"
                                {...bindToggle(popupState)}
                              />
                              <Popper
                                {...bindPopper(popupState)}
                                transition
                                placement="bottom-start"
                                style={{ zIndex: 5 }}
                              >
                                {({ TransitionProps }) => (
                                  <ClickAwayListener
                                    onClickAway={() => popupState.close()}
                                  >
                                    <Fade {...TransitionProps} timeout={350}>
                                      <Paper sx={{ p: 2 }}>
                                        <EthiopianDatePicker
                                          selectedDate={daysInput}
                                          setSelectedDate={setDaysInput}
                                          month={daysInput}
                                        />
                                      </Paper>
                                    </Fade>
                                  </ClickAwayListener>
                                )}
                              </Popper>
                            </div>
                          )}
                        </PopupState>
                      ) : (
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            value={daysInput}
                            onChange={(newValue) => {
                              setDaysInput(newValue);
                            }}
                            renderInput={(startProps) => (
                              <TextField {...startProps} error={errors[6]} />
                            )}
                            minDate={new Date().setHours(0, 0, 0, 0)}
                          />
                        </LocalizationProvider>
                      )}
                    </Grid>
                  </Grid>
                }
              />
              <Divider />
              <FormControlLabel
                value="dateRange"
                control={<Radio />}
                label={
                  <Grid container alignItems="center" spacing={2}>
                    <Grid item>
                      <Typography>Within a date range</Typography>
                    </Grid>
                    <Grid item>
                      {props.decodedToken.calendar == "Ethiopian" ? (
                        <Grid item className="flex align">
                          <PopupState variant="popper" popupId="daterangea">
                            {(popupState) => (
                              <div>
                                <OutlinedInput
                                  label="Date"
                                  value={habeshaFormat(
                                    new Date(value[0]),
                                    "MMMdd yyyy"
                                  )}
                                  variant="contained"
                                  {...bindToggle(popupState)}
                                />
                                <Popper
                                  {...bindPopper(popupState)}
                                  transition
                                  placement="bottom-start"
                                  style={{ zIndex: 5 }}
                                >
                                  {({ TransitionProps }) => (
                                    <ClickAwayListener
                                      onClickAway={() => popupState.close()}
                                    >
                                      <Fade {...TransitionProps} timeout={350}>
                                        <Paper sx={{ p: 2 }}>
                                          <EthiopianDatePicker
                                            selectedDate={value[0]}
                                            setSelectedDate={(newDate) => {
                                              setValue((prevValue) => [
                                                newDate,
                                                ...prevValue.slice(1),
                                              ]);
                                            }}
                                            max={value[1]}
                                            month={value[0]}
                                          />
                                        </Paper>
                                      </Fade>
                                    </ClickAwayListener>
                                  )}
                                </Popper>
                              </div>
                            )}
                          </PopupState>
                          <Box sx={{ mx: 2 }}> to </Box>{" "}
                          <PopupState variant="popper" popupId="daterangeb">
                            {(popupState) => (
                              <div>
                                <OutlinedInput
                                  label="Date"
                                  value={habeshaFormat(
                                    new Date(value[1]),
                                    "MMMdd yyyy"
                                  )}
                                  variant="contained"
                                  {...bindToggle(popupState)}
                                />
                                <Popper
                                  {...bindPopper(popupState)}
                                  transition
                                  placement="bottom-start"
                                  style={{ zIndex: 5 }}
                                >
                                  {({ TransitionProps }) => (
                                    <ClickAwayListener
                                      onClickAway={() => popupState.close()}
                                    >
                                      <Fade {...TransitionProps} timeout={350}>
                                        <Paper sx={{ p: 2 }}>
                                          <EthiopianDatePicker
                                            selectedDate={value[1]}
                                            setSelectedDate={(newDate) => {
                                              // Update the second element of the value array
                                              setValue((prevValue) => [
                                                prevValue[0],
                                                newDate,
                                              ]);
                                            }}
                                            min={value[0]}
                                            month={value[1]}
                                          />
                                        </Paper>
                                      </Fade>
                                    </ClickAwayListener>
                                  )}
                                </Popper>
                              </div>
                            )}
                          </PopupState>
                        </Grid>
                      ) : (
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DateRangePicker
                            value={value}
                            onChange={(newValue) => {
                              setValue(newValue);
                            }}
                            renderInput={(startProps, endProps) => (
                              <React.Fragment>
                                <TextField
                                  id="date1"
                                  {...startProps}
                                  error={errors[1]}
                                />
                                <Box sx={{ mx: 2 }}> to </Box>
                                <TextField
                                  id="date2"
                                  {...endProps}
                                  error={errors[2]}
                                />
                              </React.Fragment>
                            )}
                            minDate={new Date().setHours(0, 0, 0, 0)}
                          />
                        </LocalizationProvider>
                      )}
                    </Grid>
                  </Grid>
                }
              />
              <Divider />
              <FormControlLabel
                id="recur1"
                value="indefinitely"
                control={<Radio />}
                label={
                  <Grid container alignItems="center" spacing={2}>
                    <Grid item>
                      <Typography>Indefinitely into the future from</Typography>
                    </Grid>
                    <Grid item>
                      {props.decodedToken.calendar == "Ethiopian" ? (
                        <PopupState variant="popper" popupId="indefpopper">
                          {(popupState) => (
                            <div>
                              <OutlinedInput
                                label="Date"
                                value={habeshaFormat(
                                  new Date(daysIndefInput),
                                  "MMMdd yyyy"
                                )}
                                variant="contained"
                                {...bindToggle(popupState)}
                              />
                              <Popper
                                {...bindPopper(popupState)}
                                transition
                                placement="bottom-start"
                                style={{ zIndex: 5 }}
                              >
                                {({ TransitionProps }) => (
                                  <ClickAwayListener
                                    onClickAway={() => popupState.close()}
                                  >
                                    <Fade {...TransitionProps} timeout={350}>
                                      <Paper sx={{ p: 2 }}>
                                        <EthiopianDatePicker
                                          selectedDate={daysIndefInput}
                                          setSelectedDate={setDaysIndefInput}
                                          month={daysIndefInput}
                                        />
                                      </Paper>
                                    </Fade>
                                  </ClickAwayListener>
                                )}
                              </Popper>
                            </div>
                          )}
                        </PopupState>
                      ) : (
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            value={daysIndefInput}
                            onChange={(newValue) => {
                              setDaysIndefInput(newValue);
                            }}
                            renderInput={(startProps) => (
                              <TextField {...startProps} error={errors[7]} />
                            )}
                            minDate={new Date().setHours(0, 0, 0, 0)}
                          />
                        </LocalizationProvider>
                      )}
                    </Grid>
                  </Grid>
                }
              />
              <Divider />
              <FormControlLabel
                value="recur1"
                control={<Radio />}
                label={
                  <Grid container alignItems="center" spacing={2}>
                    <Grid item>
                      <Typography>Repeat every</Typography>
                    </Grid>
                    <Grid item>
                      <Select
                        style={{
                          height: "40px",
                        }}
                        type="text"
                        value={recurring1}
                        onChange={(event) => setRecurring1(event.target.value)}
                        inputProps={{
                          maxLength: 3,
                        }}
                      >
                        <MenuItem value="week">week</MenuItem>
                        <MenuItem value="month">month</MenuItem>
                        <MenuItem value="year">year</MenuItem>
                      </Select>
                    </Grid>
                    <Grid item>
                      <Typography>on</Typography>
                    </Grid>
                    <Grid item>
                      {props.decodedToken.calendar == "Ethiopian" ? (
                        <PopupState variant="popper" popupId="recurpoppera">
                          {(popupState) => (
                            <div>
                              <OutlinedInput
                                label="Date"
                                value={habeshaFormat(
                                  new Date(recurringValue1),
                                  "MMMdd yyyy"
                                )}
                                variant="contained"
                                {...bindToggle(popupState)}
                              />
                              <Popper
                                {...bindPopper(popupState)}
                                transition
                                placement="bottom-start"
                                style={{ zIndex: 5 }}
                              >
                                {({ TransitionProps }) => (
                                  <ClickAwayListener
                                    onClickAway={() => popupState.close()}
                                  >
                                    <Fade {...TransitionProps} timeout={350}>
                                      <Paper sx={{ p: 2 }}>
                                        <EthiopianDatePicker
                                          selectedDate={recurringValue1}
                                          setSelectedDate={setRecurringValue1}
                                          month={recurringValue1}
                                        />
                                      </Paper>
                                    </Fade>
                                  </ClickAwayListener>
                                )}
                              </Popper>
                            </div>
                          )}
                        </PopupState>
                      ) : (
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            value={recurringValue1}
                            onChange={(newValue) => {
                              setRecurringValue1(newValue);
                            }}
                            renderInput={(startProps) => (
                              <TextField {...startProps} error={errors[3]} />
                            )}
                            minDate={new Date().setHours(0, 0, 0, 0)}
                          />
                        </LocalizationProvider>
                      )}
                    </Grid>
                  </Grid>
                }
              />
              <Divider />
              <FormControlLabel
                id="recur2"
                value="recur2"
                control={<Radio />}
                label={
                  <Grid container alignItems="center" spacing={2}>
                    <Grid item>
                      <Typography>Recur every</Typography>
                    </Grid>
                    <Grid item>
                      <OutlinedInput
                        id="recur2Input"
                        error={errors[5]}
                        style={{
                          width: "60px",
                          height: "40px",
                          fontSize: "1rem",
                          textAlign: "center",
                          borderRadius: "10px",
                        }}
                        type="text"
                        value={recurring2}
                        onChange={(event) => setRecurring2(event.target.value)}
                        onKeyPress={handleKeyPress}
                        inputProps={{
                          textAlign: "center",
                          maxLength: 3,
                        }}
                      />
                    </Grid>
                    <Grid item>
                      <Typography>days following the initial date:</Typography>
                    </Grid>
                    <Grid item>
                      {props.decodedToken.calendar == "Ethiopian" ? (
                        <PopupState variant="popper" popupId="recurpoppera">
                          {(popupState) => (
                            <div>
                              <OutlinedInput
                                label="Date"
                                value={habeshaFormat(
                                  new Date(recurringValue2),
                                  "MMMdd yyyy"
                                )}
                                variant="contained"
                                {...bindToggle(popupState)}
                              />
                              <Popper
                                {...bindPopper(popupState)}
                                transition
                                placement="bottom-start"
                                style={{ zIndex: 5 }}
                              >
                                {({ TransitionProps }) => (
                                  <ClickAwayListener
                                    onClickAway={() => popupState.close()}
                                  >
                                    <Fade {...TransitionProps} timeout={350}>
                                      <Paper sx={{ p: 2 }}>
                                        <EthiopianDatePicker
                                          selectedDate={recurringValue2}
                                          setSelectedDate={setRecurringValue2}
                                          month={recurringValue2}
                                        />
                                      </Paper>
                                    </Fade>
                                  </ClickAwayListener>
                                )}
                              </Popper>
                            </div>
                          )}
                        </PopupState>
                      ) : (
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            value={recurringValue2}
                            onChange={(newValue) => {
                              setRecurringValue2(newValue);
                            }}
                            renderInput={(startProps) => (
                              <TextField error={errors[4]} {...startProps} />
                            )}
                            minDate={new Date().setHours(0, 0, 0, 0)}
                          />
                        </LocalizationProvider>
                      )}
                    </Grid>
                  </Grid>
                }
              />
            </RadioGroup>
            {bookingOption === "recur2" && errors[5] && (
              <div style={{ marginTop: 20, color: "red" }}>
                Please set the days count to at least 2
              </div>
            )}
          </div>
        </div>
        <Divider />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "30px 40px",
            gap: "15px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
            <h4 style={{ margin: 0 }}>Duration</h4>
            <Tool num={1} />
          </div>
          <Select
            value={select}
            onChange={(event) => setSelect(event.target.value)}
            variant="outlined"
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              maxWidth: "300px",
              height: "56px",
              paddingLeft: "5px",
            }}
          >
            {optionsSelect.map((val) => (
              <MenuItem value={val}>{val}</MenuItem>
            ))}
          </Select>
          {select == "Custom" && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                maxWidth: "300px",
                height: "56px",
                gap: "10px",
              }}
            >
              <OutlinedInput
                onChange={(e) => setHrsOMins(e.target.value)}
                value={hrsOmins}
                style={{ flex: 1 }}
                id="hrsOMins"
                error={errors[0]}
              />
              <Select
                value={typeOTime}
                onChange={(event) => setType(event.target.value)}
                variant="outlined"
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  flex: 1,
                  height: "56px",
                }}
              >
                <MenuItem value="min">min</MenuItem>
                <MenuItem value="hrs">hrs</MenuItem>
              </Select>
            </div>
          )}
        </div>
        <Divider />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "30px 40px",
            gap: "15px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
            <h4 style={{ margin: 0 }}>
              When are you available for this event?
            </h4>
            <Tool num={2} />
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "15px",
              height: "60px",
            }}
          >
            <Button
              variant="outlined"
              onClick={() => {
                setCustom(false);
                setSelects(groupDataPre.getCompanyGroupsHours[0]);
              }}
            >
              Use an existing schedule
            </Button>
            <Button
              variant="outlined"
              onClick={() => {
                setCustom(true);
                hasCreated ? setCustom(true) : handleCreateCustomGroup();
              }}
            >
              Set custom hours
            </Button>
          </div>
          {loading ||
          groupLoading ||
          groupLoadingPre ||
          overrideLoading ||
          overrideGroupLoading ? (
            "Loading..."
          ) : custom ? (
            <>
              {hasCreated ? (
                <Card
                  style={{
                    maxWidth: "1000px",
                    width: "90%",
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                    padding: "10px 30px",
                  }}
                >
                  <h5 style={{ height: "0px" }}>Set your weekly hours</h5>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    {[
                      { day: "Monday" },
                      { day: "Tuesday" },
                      { day: "Wednesday" },
                      { day: "Thursday" },
                      { day: "Friday" },
                      { day: "Saturday" },
                      { day: "Sunday" },
                    ].map((val, ind) => (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <div
                          style={{
                            padding: "15px 0 ",
                            gap: "20px",
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          {data.getCompanyHours.find(
                            (obj) =>
                              obj?.onJob == true &&
                              obj?.day == val.day &&
                              parseInt(groupId) == parseInt(obj?.groupId)
                          ) ? (
                            data.getCompanyHours
                              .filter(
                                (obj) =>
                                  obj?.day == val.day &&
                                  parseInt(groupId) == parseInt(obj?.groupId)
                              )
                              .map((val, ind) => (
                                <div>
                                  <div
                                    style={{
                                      display: "flex",
                                      gap: "40px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        gap: "5px",
                                        width: "78px",
                                        minWidth: "78px",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Checkbox
                                        style={{
                                          display: ind ? "none" : "inherit",
                                        }}
                                        checked={val.onJob}
                                        onClick={() => {
                                          handleUpdateMondayHours(
                                            parseInt(val.id),
                                            "check",
                                            !val.onJob
                                          );
                                        }}
                                      />
                                      <h5
                                        style={{
                                          display: ind ? "none" : "inherit",
                                        }}
                                      >
                                        {val.day.substring(0, 3).toUpperCase()}
                                      </h5>
                                    </div>
                                    <div
                                      style={{
                                        width: "300px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px",
                                      }}
                                    >
                                      <OutlinedInput
                                        style={{
                                          maxWidth: "100px",
                                          borderRadius: "10px",
                                          textTransform: "lowercase",
                                        }}
                                        value={
                                          currentInputValues[val.day]?.find(
                                            (input) => input.id == val.id
                                          )?.start ||
                                          val.startTime.toLowerCase()
                                        }
                                        onChange={(event) => {
                                          handleInputChange(
                                            parseInt(val.id),
                                            "start",
                                            event.target.value,
                                            val.day
                                          );
                                        }}
                                      />
                                      -
                                      <OutlinedInput
                                        style={{
                                          maxWidth: "100px",
                                          borderRadius: "10px",
                                        }}
                                        value={
                                          currentInputValues[val.day]?.find(
                                            (input) => input.id == val.id
                                          )?.end || val.endTime.toLowerCase()
                                        }
                                        onChange={(event) => {
                                          handleInputChange(
                                            parseInt(val.id),
                                            "end",
                                            event.target.value,
                                            val.day
                                          );
                                        }}
                                      />
                                      <IconButton
                                        onClick={() =>
                                          deleteCompanyHour({
                                            variables: {
                                              id: parseInt(val.id),
                                            },
                                          })
                                            .then((_res) => {
                                              if (
                                                currentInputValues[
                                                  val.day
                                                ].find(
                                                  (vall) => val.id == vall.id
                                                )
                                              ) {
                                                currentInputValues[val.day] =
                                                  currentInputValues[
                                                    val.day
                                                  ].filter(
                                                    (vall) => vall.id != val.id
                                                  );
                                              }
                                              refetch({
                                                userId: props.currentUser,
                                                hours24: HourFormat(),
                                              });
                                            })
                                            .catch((err) => {
                                              refetch({
                                                userId: props.currentUser,
                                                hours24: HourFormat(),
                                              });
                                              groupRefetch();
                                              console.log(err);
                                            })
                                        }
                                      >
                                        <Delete />
                                      </IconButton>
                                    </div>
                                    <div
                                      style={{
                                        display: ind == 0 ? "flex" : "none",
                                        justifyContent: "flex-end",
                                        gap: "10px",
                                        alignItems: "center",
                                        flex: 2,
                                      }}
                                    >
                                      {" "}
                                      <Button
                                        onClick={() => {
                                          handleSaveClick(val.day);
                                        }}
                                        variant="contained"
                                        style={{
                                          display:
                                            (currentInputValues[val.day]
                                              ? !currentInputValues[val.day]
                                                  ?.length ||
                                                currentInputValues[val.day][0]
                                                  ?.groupId !=
                                                  parseInt(
                                                    custom ? groupId : selects
                                                  )
                                              : true) && "none",
                                        }}
                                      >
                                        SAVE
                                      </Button>
                                      <IconButton
                                        onClick={() => {
                                          var companyHours =
                                            data?.getCompanyHours
                                              .filter(
                                                (obj) =>
                                                  obj.day == val.day &&
                                                  parseInt(
                                                    custom ? groupId : selects
                                                  ) == parseInt(obj.groupId)
                                              )
                                              .slice(-1)[0];

                                          var updatedHours = {
                                            ...companyHours,
                                          };

                                          updatedHours.startTime = format(
                                            new Date(
                                              addHours(
                                                parse(
                                                  updatedHours.startTime,
                                                  HourFormat(),
                                                  new Date()
                                                ),
                                                1
                                              )
                                            ),
                                            HourFormat()
                                          );

                                          updatedHours.endTime = format(
                                            new Date(
                                              addHours(
                                                parse(
                                                  updatedHours.endTime,
                                                  HourFormat(),
                                                  new Date()
                                                ),
                                                1
                                              )
                                            ),
                                            HourFormat()
                                          );

                                          const allHours =
                                            data?.getCompanyHours.filter(
                                              (obj) =>
                                                obj.day == val.day &&
                                                parseInt(
                                                  custom ? groupId : selects
                                                ) == parseInt(obj.groupId)
                                            );

                                          for (
                                            var i = 0;
                                            i < allHours.length;
                                            i++
                                          ) {
                                            if (
                                              isTimeRangeOverlap(
                                                updatedHours,
                                                allHours[i]
                                              ) &&
                                              i !=
                                                allHours.indexOf(companyHours)
                                            ) {
                                              var good = false;
                                              for (var j = 0; j < 24; j++) {
                                                var updatedUpdatedHours = {
                                                  ...updatedHours,
                                                };

                                                updatedUpdatedHours.startTime =
                                                  format(
                                                    new Date(
                                                      addHours(
                                                        parse(
                                                          updatedUpdatedHours.startTime,
                                                          HourFormat(),
                                                          new Date()
                                                        ),
                                                        j
                                                      )
                                                    ),
                                                    HourFormat()
                                                  );

                                                updatedUpdatedHours.endTime =
                                                  format(
                                                    new Date(
                                                      addHours(
                                                        parse(
                                                          updatedUpdatedHours.endTime,
                                                          HourFormat(),
                                                          new Date()
                                                        ),
                                                        j
                                                      )
                                                    ),
                                                    HourFormat()
                                                  );

                                                if (
                                                  !isTimeRangeOverlap(
                                                    updatedUpdatedHours,
                                                    allHours
                                                  )
                                                ) {
                                                  updatedUpdatedHours.startTime =
                                                    format(
                                                      new Date(
                                                        addHours(
                                                          parse(
                                                            updatedUpdatedHours.startTime,
                                                            HourFormat(),
                                                            new Date()
                                                          ),
                                                          -1
                                                        )
                                                      ),
                                                      HourFormat()
                                                    );

                                                  updatedUpdatedHours.endTime =
                                                    format(
                                                      new Date(
                                                        addHours(
                                                          parse(
                                                            updatedUpdatedHours.endTime,
                                                            HourFormat(),
                                                            new Date()
                                                          ),
                                                          -1
                                                        )
                                                      ),
                                                      HourFormat()
                                                    );
                                                  good = true;

                                                  companyHours =
                                                    updatedUpdatedHours;
                                                  break;
                                                }
                                              }
                                              if (!good) {
                                                setErrorUpdating(
                                                  "Overlapping Dates"
                                                );
                                                return;
                                              } else {
                                                break;
                                              }
                                            }
                                          }
                                          if (companyHours) {
                                            const endTime = parse(
                                              companyHours?.endTime || "5:00pm",
                                              HourFormat(),
                                              new Date()
                                            );
                                            const newStartTime = addHours(
                                              endTime,
                                              0
                                            );
                                            let newEndTime = addHours(
                                              endTime,
                                              1
                                            );

                                            createNewAvailability({
                                              userId: props.currentUser,
                                              onJob: true,
                                              day: val.day,
                                              startTime: format(
                                                newStartTime,
                                                "hh:mmaa"
                                              ),
                                              endTime: format(
                                                newEndTime,
                                                "hh:mmaa"
                                              ),
                                              groupId: parseInt(
                                                custom ? groupId : selects
                                              ),
                                            });
                                          } else {
                                            // No company hours found for this day and group, create a new 9 to 5 schedule
                                            createNewAvailability({
                                              userId: props.currentUser,
                                              onJob: true,
                                              day: val.day,
                                              startTime: "9:00am",
                                              endTime: "5:00pm",
                                              groupId: parseInt(
                                                custom ? groupId : selects
                                              ),
                                            });
                                          }
                                        }}
                                      >
                                        <Add />
                                      </IconButton>
                                    </div>
                                  </div>
                                </div>
                              ))
                          ) : (
                            <div>
                              <div
                                style={{
                                  display: "flex",
                                  gap: "40px",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    gap: "5px",
                                    width: "78px",
                                    minWidth: "78px",
                                    alignItems: "center",
                                  }}
                                >
                                  <Checkbox
                                    checked={false}
                                    onClick={() => {
                                      data.getCompanyHours.find(
                                        (obj) =>
                                          obj?.day == val.day &&
                                          parseInt(groupId) ==
                                            parseInt(obj?.groupId)
                                      )
                                        ? handleUpdateMondayHours(
                                            parseInt(
                                              data.getCompanyHours.find(
                                                (obj) =>
                                                  obj?.day == val.day &&
                                                  parseInt(groupId) ==
                                                    parseInt(obj?.groupId)
                                              )?.id
                                            ),
                                            "check",
                                            true
                                          )
                                        : createNewAvailability({
                                            userId: props.currentUser,
                                            onJob: true,
                                            day: val.day,
                                            startTime: "9:00am",
                                            endTime: "5:00pm",
                                            groupId: parseInt(groupId),
                                          });
                                    }}
                                  />
                                  <h5>
                                    {val.day.substring(0, 3).toUpperCase()}
                                  </h5>
                                </div>
                                <div
                                  style={{
                                    width: "300px",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                  }}
                                >
                                  <Typography>Unavailable</Typography>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    gap: "10px",
                                    alignItems: "center",
                                    flex: 2,
                                  }}
                                >
                                  <IconButton
                                    onClick={() => {
                                      createNewAvailability({
                                        userId: props.currentUser,
                                        onJob: true,
                                        day: val.day,
                                        startTime: "9:00am",
                                        endTime: "5:00pm",
                                        groupId: parseInt(groupId),
                                      });
                                    }}
                                  >
                                    <Add />
                                  </IconButton>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                        <Divider />
                      </div>
                    ))}
                  </div>
                </Card>
              ) : (
                <Typography>Creating....</Typography>
              )}
            </>
          ) : (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "15px",
                }}
              >
                <h4 style={{ margin: 0 }}>
                  Which schedule do you want to use?
                </h4>
                <Select
                  value={selects}
                  onChange={(e) => {
                    setSelects(e.target.value);
                  }}
                >
                  {groupDataPre.getCompanyGroupsHours.map((val, ind) => (
                    <MenuItem value={val?.id}>{val?.title}</MenuItem>
                  ))}
                </Select>
              </div>
              <Card style={{ display: "flex" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "25px",
                    padding: "30px 0",
                    flex: 1,
                  }}
                >
                  {[
                    { day: "Monday" },
                    { day: "Tuesday" },
                    { day: "Wednesday" },
                    { day: "Thursday" },
                    { day: "Friday" },
                    { day: "Saturday" },
                    { day: "Sunday" },
                  ].map((val) => (
                    <div>
                      {data.getCompanyHours.find(
                        (obj) =>
                          obj?.day == val.day &&
                          parseInt(obj?.groupId) == parseInt(selects)
                      ) ? (
                        data.getCompanyHours
                          .filter(
                            (obj) =>
                              obj?.day == val.day &&
                              parseInt(obj?.groupId) == parseInt(selects)
                          )
                          .map((val, ind) => (
                            <div
                              style={{
                                height: "40px",
                                display: "flex",
                                gap: "40px",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  gap: "5px",
                                  width: "78px",
                                  minWidth: "78px",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <h5 style={{ display: ind ? "none" : "flex" }}>
                                  {val.day.substring(0, 3).toUpperCase()}
                                </h5>
                              </div>
                              <div
                                style={{
                                  width: "300px",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                }}
                              >
                                {val.onJob ? (
                                  <>
                                    <h4 className="input-label">
                                      {val.startTime.toLowerCase()}
                                    </h4>{" "}
                                    -
                                    <h4 className="input-label">
                                      {val.endTime.toLowerCase()}
                                    </h4>
                                  </>
                                ) : (
                                  <h4
                                    className="input-label"
                                    style={{ opacity: "50%" }}
                                  >
                                    {" "}
                                    Unavailable
                                  </h4>
                                )}
                              </div>
                            </div>
                          ))
                      ) : (
                        <div
                          style={{
                            height: "40px",
                            display: "flex",
                            gap: "40px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              gap: "5px",
                              width: "78px",
                              minWidth: "78px",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <h5 style={{ display: "flex" }}>
                              {val.day.substring(0, 3).toUpperCase()}
                            </h5>
                          </div>
                          <div
                            style={{
                              width: "300px",
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                            }}
                          >
                            <h4
                              className="input-label"
                              style={{ opacity: "50%" }}
                            >
                              {" "}
                              Unavailable
                            </h4>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
                <Divider orientation="vertical" />
                <div style={{ flex: 2, display: "flex" }}>
                  <Divider orientation="vertical" />
                  <div style={{ padding: "30px 20px", width: "100%" }}>
                    <h4 className="font">DATE OVERRIDES</h4>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        maxHeight: "530px",
                        overflow: "auto",
                        marginTop: "20px",
                        gap: "5px",
                      }}
                    >
                      {overrideGroupData?.getOverrideGroups?.filter(
                        (val) => val.groupId == selects
                      )?.length ? (
                        overrideGroupData?.getOverrideGroups
                          ?.filter((val) => val.groupId == selects)
                          .map((val) => (
                            <div style={{ display: "flex" }}>
                              <div style={{ flex: 1 }}>
                                <Typography
                                  className="font2"
                                  style={{ opacity: "100%", color: "black" }}
                                >
                                  {format(new Date(val.date), "MMM dd, yyyy")}
                                </Typography>
                              </div>
                              <div style={{ flex: 1 }}>
                                {overrideData?.getOverrides?.filter(
                                  (vall) => vall.groupId == val.id
                                )?.length ? (
                                  overrideData?.getOverrides
                                    ?.filter((vall) => vall.groupId == val.id)
                                    .map((val) => (
                                      <Typography>
                                        {val.startTime + " - " + val.endTime}
                                      </Typography>
                                    ))
                                ) : (
                                  <Typography className="font2">
                                    Unavailable
                                  </Typography>
                                )}
                              </div>
                            </div>
                          ))
                      ) : (
                        <Typography
                          className="font2"
                          style={{ textAlign: "center" }}
                        >
                          To override your hours on specific dates, update your
                          schedule under Availability
                        </Typography>
                      )}
                    </div>
                  </div>
                </div>
              </Card>
            </>
          )}
        </div>
        <Divider />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "30px 40px",
            gap: "15px",
          }}
        >
          <h4 style={{ margin: 0 }}>
            Buffer times before and after a confirmed meeting
          </h4>
        </div>
        <div
          style={{
            minHeight: "104px",
            padding: "0 50px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Typography
            style={{
              color: "#1976d2",
              cursor: "pointer",
              alignItems: "center",
              display: "flex",
            }}
            onClick={() => setAdvancedOpen(!advancedOpen)}
          >
            Additional Rules for availability{" "}
            {advancedOpen ? <KeyboardArrowDown /> : <ChevronRight />}
          </Typography>
        </div>
        {advancedOpen && (
          <>
            <Divider />
            <div
              style={{
                padding: "40px 50px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                maxWidth: "400px",
                gap: "20px",
              }}
            >
              <Typography
                style={{
                  alignItems: "center",
                  display: "flex",
                  fontSize: "20px",
                }}
                className="font"
                onClick={() => setAdvancedOpen(!advancedOpen)}
              >
                Start time increments
              </Typography>{" "}
              <div
                style={{
                  width: "100%",
                }}
              >
                <Typography className="font">
                  Show available start times in increments of...
                </Typography>
                <Select
                  sx={{ "& .MuiSvgIcon-root": { color: "blue" } }}
                  value={increments}
                  onChange={(e) => setIncrements(e.target.value)}
                  IconComponent={ExpandMore}
                  fullWidth
                >
                  {[5, 10, 15, 20, 30, 45, 60].map((val) => (
                    <MenuItem value={val}>{val} mins</MenuItem>
                  ))}
                </Select>
              </div>
            </div>
            <Divider />{" "}
            {!props.group || props.update?.group ? (
              <>
                {" "}
                <div
                  style={{
                    padding: "40px 50px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    maxWidth: "400px",
                    gap: "20px",
                  }}
                >
                  <Typography
                    style={{
                      alignItems: "center",
                      display: "flex",
                      fontSize: "20px",
                    }}
                    className="font"
                    onClick={() => setAdvancedOpen(!advancedOpen)}
                  >
                    Scheduling conditions
                  </Typography>
                  <div
                    style={{
                      width: "100%",
                    }}
                  >
                    <Typography className="font">
                      Maximum allowed events per day for this type of event
                    </Typography>
                    <OutlinedInput
                      inputProps={{ min: 0, style: { textAlign: "center" } }}
                      style={{
                        width: "100%",
                        maxWidth: "65px",
                        height: "60px",
                      }}
                      value={eventsPerDay}
                      onChange={(e) => setEventsPerDay(e.target.value)}
                      fullWidth
                    />
                  </div>
                </div>
                <Divider />
              </>
            ) : (
              ""
            )}
            <div
              style={{
                padding: "40px 50px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                maxWidth: "400px",
                gap: "10px",
              }}
            >
              <Typography className="font">Secret Event</Typography>
              <div
                style={{ display: "flex", gap: "7px", alignItems: "center" }}
              >
                <SimplePopper
                  anchorEl={anchorEl}
                  handleAwayClick={() => {
                    setAnchorEl(null);
                  }}
                />
                <Checkbox
                  sx={{
                    padding: 0,
                    "&:hover": { bgcolor: "transparent" },
                  }}
                  disableRipple
                  color="default"
                  checkedIcon={<BpCheckedIcon />}
                  icon={<BpIcon />}
                  checked={hidden}
                  onChange={(e) => {
                    props.decodedToken.role.toLowerCase() == "starter"
                      ? handleClick(e)
                      : setHidden(!hidden);
                  }}
                  inputProps={{ "aria-label": "Checkbox demo" }}
                />
                <Typography>Make this a secret event</Typography>
              </div>
              <Typography className="font2" style={{ fontSize: "13px" }}>
                Only invitees who have this Calendly link can schedule with you.
              </Typography>
            </div>
            <Divider />
            <div
              style={{
                padding: "40px 50px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                gap: "10px",
              }}
            >
              <Typography className="font">Images</Typography>
              <Card
                style={{ width: "100%", maxWidth: "600px", padding: "20px" }}
                className="flex column"
              >
                <OutlinedInput
                  fullWidth
                  style={{ borderRadius: "100px", marginBottom: "20px" }}
                  value={searchImages}
                  startAdornment={<Search style={{ margin: "0px 10px" }} />}
                  onChange={(e) => setSearchImages(e.target.value)}
                />
                <Grid
                  container
                  style={{ maxHeight: "286px", overflow: "auto" }}
                >
                  {images
                    .filter(
                      (val) =>
                        val?.id &&
                        val?.desc &&
                        val.desc.toLowerCase().includes(searchImages)
                    )
                    .map((val) => {
                      return (
                        val.image && (
                          <Grid
                            item
                            xs={12}
                            sm={6}
                            md={4}
                            lg={3}
                            style={{ padding: "10px" }}
                          >
                            <div style={{ position: "relative" }}>
                              <img
                                onClick={() => setImage(val.id)}
                                src={
                                  val.image +
                                  "?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
                                }
                                style={{
                                  width: "100%",
                                  height: "auto",
                                  boxShadow:
                                    "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                                  cursor: "pointer",
                                  transition: "0.3s ease",
                                }}
                              />
                              {val.id == image && (
                                <div
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    width: "100%",
                                    height: "96%",
                                    backgroundColor: "rgba(0,0,0,0.4)",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    color: "white",
                                    fontSize: "20px",
                                  }}
                                >
                                  Selected
                                </div>
                              )}
                            </div>
                          </Grid>
                        )
                      );
                    })}
                </Grid>
              </Card>
            </div>
          </>
        )}
        <Divider />
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "20px",
          }}
        >
          <Cancel onClick={() => setShowCancelModal(true)}>Cancel</Cancel>
          <CancelModal
            isOpen={showCancelModal}
            onCancel={handleCancel}
            onNevermind={handleNevermind}
          />

          <Next
            onClick={() => {
              handleFormSubmit();
            }}
          >
            Save & Close
          </Next>
        </div>
      </div>
      {errorUpdating && (
        <div
          ref={errorRef}
          className="notification"
          style={{ width: "170px", border: "2px solid red" }}
        >
          {errorUpdating}
        </div>
      )}
    </div>
  );
};
export default EventTime;
